<template>
  <div class="container page">
    <van-nav-bar title="" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
      <template #right>
        <span class="nav-right" @click="$router.push({path:'/RechargeRecord'})">Deposit history</span>
      </template>
    </van-nav-bar>
    
    <div class="balance-section">
      <p class="balance-label">Current balance()</p>
    </div>

    <div class="main-content">
      <div class="form-section">
        <h3 class="form-title">Please enter deposit amount</h3>
        <input 
          v-model="money" 
          type="number" 
          class="amount-input" 
          placeholder="Please enter deposit amount"
        />
      </div>

      <van-button class="submit-btn" type="primary" @click="onSubmit()">Next</van-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Form } from "vant";
import { Field } from "vant";
import { RadioGroup, Radio } from "vant";
Vue.use(Form).use(Field).use(RadioGroup).use(Radio);
export default {
  data() {
    return {
      balance: 0,
      pay_way: "Qepay_QR",
      pay_way1: "Qepay_B2C",
      pay_way2: "Qepay_QR",
      win_money: 0,
      money: '',
      personalreport: {},
      rechargeData:[100,200,500,1000,3000,5000,10000,20000,30000]
    };
  },
  mounted() {
    this.balance = this.$route.params.balance;
  },
  methods: {
    back() {
      return window.history.back();
    },
    //拉起支付
    onSubmit() {
      const money = this.money;
      if (!money || money <= 0) {
        this.$toast(this.$t("reservation.money_err"));
        return;
      }
      this.$router.push({
        path: '/Channel',
        query: {
          money: money
        }
      });
    },

    getPersonalreport() {
      this.$http({
        method: "get",
        url: "user_get_personalreport",
      }).then((res) => {
        if (res.code === 200) {
          this.personalreport = res.data;
          this.win_money =
              this.personalreport.win_money - this.personalreport.play_money;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    setAmount(data){
      if(data > 0){
        this.money = data * 1000;
      }
    }
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getPersonalreport();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.page {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.nav-bar {
  background-color: #fff;
}

::v-deep .van-nav-bar__title {
  color: #333;
}

.nav-right {
  color: #5b68df;
  font-size: 0.37333rem;
}

.balance-section {
  background: linear-gradient(135deg, #667eea 0%, #667eea 100%);
  padding: 0.8rem;
  text-align: center;
}

.balance-label {
  color: #fff;
  font-size: 0.42667rem;
  margin: 0;
}

.main-content {
  padding: 0.53333rem;
}

.form-section {
  background: #fff;
  border-radius: 0.2rem;
  padding: 0.53333rem;
  margin-bottom: 0.8rem;
}

.form-title {
  font-size: 0.42667rem;
  color: #999;
  margin: 0 0 0.4rem 0;
  font-weight: normal;
}

.amount-input {
  width: 100%;
  padding: 0.4rem;
  border: 0.02667rem solid #e5e5e5;
  border-radius: 0.13333rem;
  font-size: 0.37333rem;
  outline: none;
  box-sizing: border-box;
}

.amount-input::placeholder {
  color: #ccc;
}

.submit-btn {
  width: 100%;
  height: 1.2rem;
  line-height: 1.2rem;
  border-radius: 0.6rem;
  font-size: 0.42667rem;
  font-weight: bold;
  border: none;
  background: #5B60DF;
  color: #fff;
}

::v-deep .van-button__text {
  color: #fff;
}
</style>